module.exports = __webpack_public_path__ + "static/img/academy_edu_learn_3.0f8495be.png";